(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
function satsCompactFooter(){
document.querySelectorAll('.footer-block--menu').forEach((block,i)=>{
if(block.dataset.satsCompact)return;
const heading=block.querySelector('.footer-block__heading'),list=block.querySelector('ul');
if(!heading||!list)return;
block.dataset.satsCompact='true';
const text=heading.textContent,button=document.createElement('button'),label=document.createElement('span');
label.textContent=text;label.className='sats-footer-desktop-label';
button.type='button';button.className='sats-footer-toggle';button.textContent=text;
list.id=list.id||'sats-footer-links-'+i;
button.setAttribute('aria-controls',list.id);button.setAttribute('aria-expanded','false');
heading.replaceChildren(label,button);
const mq=matchMedia('(max-width:749px)');
function sync(){label.hidden=mq.matches;button.hidden=!mq.matches;list.hidden=mq.matches&&button.getAttribute('aria-expanded')!=='true';}
button.addEventListener('click',()=>{button.setAttribute('aria-expanded',String(button.getAttribute('aria-expanded')!=='true'));sync();});
mq.addEventListener('change',sync);sync();
});
}
satsCompactFooter();
document.addEventListener('shopify:section:load',satsCompactFooter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function initSatsDesktopMenuHover() {
    const desktopMenuMedia = window.matchMedia('(min-width: 990px)');

    document.querySelectorAll('.header__inline-menu header-menu').forEach((menu) => {
      if (menu.dataset.satsHoverReady === 'true') return;

      const details = menu.querySelector(':scope > details');
      const summary = details?.querySelector(':scope > summary');
      if (!details || !summary) return;

      let closeTimer;

      const setMenuOpen = (isOpen) => {
        if (!desktopMenuMedia.matches) return;
        details.open = isOpen;
        summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      };

      menu.addEventListener('mouseenter', () => {
        window.clearTimeout(closeTimer);
        setMenuOpen(true);
      });

      menu.addEventListener('mouseleave', () => {
        closeTimer = window.setTimeout(() => setMenuOpen(false), 140);
      });

      menu.addEventListener('focusout', (event) => {
        if (!menu.contains(event.relatedTarget)) {
          setMenuOpen(false);
        }
      });

      menu.dataset.satsHoverReady = 'true';
    });
  }

  initSatsDesktopMenuHover();
  document.addEventListener('shopify:section:load', initSatsDesktopMenuHover);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sats-customer-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sats-customer-review-slider')) {
customElements.define('sats-customer-review-slider', class extends HTMLElement {
  connectedCallback() {
    this.track=this.querySelector('.sats-reviews__grid');
    this.cards=Array.from(this.querySelectorAll('.sats-reviews__card'));
    if(this.cards.length<2)return;
    this.abort=new AbortController();
    const options={signal:this.abort.signal};
    this.motion=matchMedia('(prefers-reduced-motion: reduce)');
    this.paused=this.motion.matches;
    this.visible=false;this.index=0;
    this.toggle=this.querySelector('[data-toggle]');
    this.counter=this.querySelector('[data-counter]');
    this.controls=this.querySelector('.sats-reviews__controls');
    this.querySelector('[data-next]').addEventListener('click',()=>this.move(1,true),options);
    this.querySelector('[data-prev]').addEventListener('click',()=>this.move(-1,true),options);
    this.toggle.addEventListener('click',()=>{this.paused=!this.paused;this.update();},options);
    this.track.addEventListener('keydown',event=>{
      if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.move(event.key==='ArrowRight'?1:-1,true);}
    },options);
    this.track.addEventListener('pointerdown',()=>{this.paused=true;this.update();},options);
    this.track.addEventListener('scroll',()=>{
      clearTimeout(this.scrollTimer);
      this.scrollTimer=setTimeout(()=>{
        this.index=this.positions.reduce((best,p,i)=>Math.abs(p-this.track.scrollLeft)<Math.abs(this.positions[best]-this.track.scrollLeft)?i:best,0);
        this.update();
      },150);
    },options);
    this.motion.addEventListener('change',()=>{if(this.motion.matches){this.paused=true;this.update();}},options);
    this.resize=new ResizeObserver(()=>this.measure());
    this.resize.observe(this.track);
    this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;},{threshold:.35});
    this.observer.observe(this);
    this.measure();
    this.timer=setInterval(()=>{
      if(!this.paused&&this.visible&&!document.hidden&&!this.matches(':hover')&&!this.contains(document.activeElement))this.move(1);
    },8000);
  }
  measure(){
    const max=Math.max(0,this.track.scrollWidth-this.track.clientWidth);
    const origin=this.cards[0].offsetLeft;
    this.positions=[...new Set(this.cards.map(card=>Math.min(max,Math.max(0,card.offsetLeft-origin))))];
    this.index=Math.min(this.index,this.positions.length-1);
    this.controls.hidden=this.positions.length<2;
    this.track.scrollTo({left:this.positions[this.index],behavior:'instant'});
    this.update();
  }
  move(direction,manual=false){
    if(manual)this.paused=true;
    this.index=(this.index+direction+this.positions.length)%this.positions.length;
    this.track.scrollTo({left:this.positions[this.index],behavior:this.motion.matches?'instant':'smooth'});
    this.update();
  }
  update(){
    this.dataset.current=String(this.index+1);
    this.toggle.textContent=this.paused?this.dataset.play:this.dataset.pause;
    const left=this.positions[this.index],right=left+this.track.clientWidth,origin=this.cards[0].offsetLeft;
    const shown=this.cards.map((card,i)=>({i,left:card.offsetLeft-origin,right:card.offsetLeft-origin+card.offsetWidth})).filter(card=>card.left>=left-3&&card.right<=right+3);
    const first=shown.length?shown[0].i+1:this.index+1;
    const last=shown.length?shown[shown.length-1].i+1:first;
    this.counter.textContent=(first===last?String(first):first+'–'+last)+' / '+this.cards.length;
  }
  disconnectedCallback(){
    clearInterval(this.timer);clearTimeout(this.scrollTimer);
    this.abort?.abort();this.resize?.disconnect();this.observer?.disconnect();
  }
});
}

  } catch(e) { console.error(e); }
})();
})();
